/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type EmptyCartMutationVariables = {||};
export type EmptyCartMutationResponse = {|
  +emptyCart: ?{|
    +cartId: ?string
  |}
|};
export type EmptyCartMutation = {|
  variables: EmptyCartMutationVariables,
  response: EmptyCartMutationResponse,
|};
*/


/*
mutation EmptyCartMutation {
  emptyCart {
    cartId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "EmptyCartPayload",
    "kind": "LinkedField",
    "name": "emptyCart",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cartId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EmptyCartMutation",
    "selections": (v0/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "EmptyCartMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "750f9b4dd6daa42327bba5cd60e83ea5",
    "id": null,
    "metadata": {},
    "name": "EmptyCartMutation",
    "operationKind": "mutation",
    "text": "mutation EmptyCartMutation {\n  emptyCart {\n    cartId\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ab5a689dc4de0a2a1ea8cb936f16785a';

module.exports = node;
